import { createSelector } from '@ngrx/store';
import { TPlani8State } from '../reducers';
import { TLLBoardState } from './ll-board.models';

export const getLLBoardState = (state: TPlani8State) => state.llBoardInfo;

export const getLineShiftInfo = createSelector(getLLBoardState, (state: TLLBoardState) => state.lineShiftInfo);
export const getLLBoardList = createSelector(getLLBoardState, (state: TLLBoardState) => state.llBoardList);
export const getLoadStripOnMouse = createSelector(getLLBoardState, (state) => state.loadStripOnMouse);
export const getLLTaskManager = createSelector(getLLBoardState, (state: TLLBoardState) => state.llTaskManager);
export const getLearningCurveStripInfo = createSelector(
  getLLBoardState,
  (state: TLLBoardState) => state.learningCurveStripInfo,
);
export const GetLearningCurveByFactoryOtl = createSelector(
  getLLBoardState,
  (state: TLLBoardState) => state.learningCurveByFactoryOtl,
);
export const GetLineStripListingInfo = createSelector(
  getLLBoardState,
  (state: TLLBoardState) => state.lineStripListingInfo,
);
export const getLineStripPlannedNumbers = createSelector(
  getLLBoardState,
  (state: TLLBoardState) => state.lineStripPlannedNumbers,
);
export const getLLLoadOrderThresholds = createSelector(
  getLLBoardState,
  (state: TLLBoardState) => state.llPCDPEDThreshold,
);
export const getPlanVersions = createSelector(getLLBoardState, (state: TLLBoardState) => state.planVersions);
export const getSelectedPlanVersion = createSelector(
  getLLBoardState,
  (state: TLLBoardState) => state.selectedPlanVersion,
);
export const getSelectedPlanVersionInfo = createSelector(
  getPlanVersions,
  getSelectedPlanVersion,
  (versions, selectedVersionId) => versions.find((version) => version.versionId === selectedVersionId),
);
export const getIsCreatingPlanVersion = createSelector(
  getLLBoardState,
  (state: TLLBoardState) => state.isCreatingPlanVersion,
);
export const getIsPromotingPlanVersion = createSelector(
  getLLBoardState,
  (state: TLLBoardState) => state.isPromotingPlanVersion,
);
